import styled, { css } from 'styled-components';

import { Typography } from '@/components/Typography';

export const Sku = styled(Typography)`
  text-transform: uppercase;
  font-family: ${({ theme }) => theme.fontFamilies.italianPlate};
  color: ${({ theme }) => theme.colors.secondaryGrey};
  font-size: ${({ theme }) => theme.fontSizes.p2};

  ${({ theme }) => css`
    ${theme.media.md.up} {
      font-size: ${theme.fontSizes.p3};
    }
  `}
`;
